<style lang="less" scoped>
</style>
<template>
  <div>
    <v-dialog
      v-model="showModal"
      max-width="500px"
      scrollable
      :persistent="true"
    >
      <v-card>
        <v-card-title>
          <span>{{ editedItem.id===undefined?'新增':'编辑' }}</span>
        </v-card-title>
        <v-card-text>
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
            @submit.native.prevent
          >
            <v-container>
              <v-row>
                <v-col
                  v-if="needTreeList"
                  cols="12"
                >
                  <v-menu
                    ref="menu"
                    v-model="showParentSelect"
                    :close-on-content-click="false"
                    :return-value.sync="parentName"
                    transition="scale-transition"
                    allow-overflow
                    min-width="290px"
                    max-height="400px"
                    offset-overflow
                    top
                  >
                    <template
                      v-slot:activator="{ on, attrs }"
                    >
                      <v-text-field
                        :value="tree_hash&&tree_hash[editedItem.parent_id]&&tree_hash[editedItem.parent_id].name"
                        label="父节点"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      />
                    </template>
                    <v-card>
                      <v-treeview
                        :open="openItem"
                        :hoverable="true"
                        :items="treeList"
                        item-key="id"
                      >
                        <template v-slot:label="{item}">
                          <v-btn
                            text
                            :color="item.id===editedItem.parent_id?'primary':''"
                            :disabled="disabled_hash[item.id]"
                            @click="selectItem(item)"
                          >
                            {{ item.name }}
                          </v-btn>
                        </template>
                      </v-treeview>               
                    </v-card>
                  </v-menu>
                </v-col>     
                <v-col
                  cols="12"
                >
                  <v-text-field
                    v-model="editedItem.name"
                    :rules="nameRules"
                    :label="fieldName"
                    required
                    @keydown="keydownSubmit"
                  />
                </v-col>
              </v-row>
              <v-row v-if="needSynonyms">
                <v-col
                  cols="12"
                >
                  <v-text-field
                    v-model="editedItem.synonymsName"
                    label="关键字"
                    placeholder="回车键记录新的词条"
                    @keydown="keydown"
                  />
                </v-col>
              </v-row>
              <v-row v-if="needSynonyms&&editedItem.synonyms.length">
                <v-col
                  cols="12"
                >
                  <v-chip
                    v-for="(item,index) in editedItem.synonyms"
                    :key="item"
                    style="margin-right:5px"
                    close
                    @click:close="close(index)"
                  >
                    {{ item }}
                  </v-chip>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            :disabled="loading"
            @click="cancel"
          >
            取消
          </v-btn>
          <v-btn
            :loading="loading"
            color="blue darken-1"
            text
            @click="save"
          >
            保存
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
  const initData = () => ({
    name:'',
    synonyms: [],
    synonymsName:'',
    parent_id: undefined
  })
  export default {
    props: {
      editFun: {
        type: Function,
      },
      loading: {
        type:Boolean,
      },
      fieldName: {
        type: String
      },
      needSynonyms: {
        type: Boolean
      },
      enterSubmit: {
        type: Boolean
      },
      treeList: {
        type: Array
      },
      needTreeList: {
        type: Boolean
      }
    },
    data() {
      this.valid = true
      this.tree_hash = {}
      this.test = ""
      return {
        showModal: false,
        showParentSelect:false,
        editedItem: initData(),
        nameRules: [
          v => !!v || '名称必填',
        ],
        parentName:'',
        openItem:[],
        disabled_hash:{}
      }
    },
    methods: {
      selectItem(data) {
        this.editedItem.parent_id = data.id
        this.showParentSelect = false
      },
      show(item = {}) {
        this.showModal = true
        this.disabled_hash = {}
        this.openItem = []
        if (this.needTreeList) {
          let stack = [ ...(this.treeList || []) ]
          while (stack.length) {
            const current = stack[stack.length - 1]
            stack.pop()
            this.tree_hash[current.id] = current
            const arr = current.children || []
            stack = stack.concat(arr)
          }
        }
        if (item.id) {
          if (this.needTreeList) { 
            // 收集不能选中的节点
            let currentNodeDisabledStack = [this.tree_hash[item.id]]
            while (currentNodeDisabledStack.length) {
              const current = currentNodeDisabledStack[currentNodeDisabledStack.length - 1]
              currentNodeDisabledStack.pop()
              this.disabled_hash[current.id] = true
              const arr = current.children || []
              currentNodeDisabledStack = currentNodeDisabledStack.concat(arr)
            }
            // 收集应该展开的节点
            let currentNode = item
            while (this.tree_hash[currentNode.id]) {
              this.openItem.push(currentNode.id)
              if (currentNode.parent_id === undefined) {
                break
              }
              currentNode = this.tree_hash[currentNode.parent_id]
            }
            if (this.openItem) {
              this.openItem.shift()
            }
          }
          Object.keys(item).forEach(key => {
            if (item[key] instanceof Array) {
              this.editedItem[key] = [...item[key]]
            } else {
              this.editedItem[key] = item[key]
            }
          })
        } else if (item && item.parent_id !== undefined) {
          if (this.needTreeList) { 
            // 收集应该展开的节点
            let currentNode = item
            while (this.tree_hash[currentNode.parent_id]) {
              this.openItem.push(currentNode.parent_id)
              if (currentNode.parent_id === undefined) {
                break
              }
              currentNode = this.tree_hash[currentNode.parent_id]
            }
            if (this.openItem) {
              this.openItem.shift()
            }
          }
          this.editedItem = initData()
          this.editedItem.parent_id = item.parent_id
         
        } else {
          this.editedItem = initData()
        }
      },
      save() {
        if (this.$refs.form.validate()) {
          if (this.editFun) {
            this.editFun({...this.editedItem, success:() => {
              this.cancel()
            }})
          }
          this.$emit('ok', {...this.editedItem, success:() => {
            this.$Message.success({
              content: this.editedItem.id ? '编辑成功' : '新增成功',
              duration:0.9
            })
            this.cancel()
          }})
        }
      },
      close(index) {
        this.editedItem.synonyms.splice(index, 1)
      },
      cancel() {
        const currentParams = initData()
        Object.keys(currentParams).forEach(key => {
          this.editedItem[key] = currentParams[key]
        })
        this.$refs.form.resetValidation()
        this.showModal = false  
      },
      keydown(e) {
        const isEnter = (e.key.toLowerCase() === 'enter' || e.code.toLowerCase() === 'enter') // enter键
        const synonymsName = this.editedItem.synonymsName.trim() // 输入的内容
        if (isEnter && synonymsName) {
          this.editedItem.synonymsName = ''
          this.editedItem.synonyms.push(synonymsName)
        }
      },
      keydownSubmit(e) {
        const isEnter = (e.key.toLowerCase() === 'enter' || e.code.toLowerCase() === 'enter') // enter键
        if (isEnter && this.enterSubmit) {
          this.save()
        }
      }
    }
  }
</script>
